import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// helpers/constants
import * as G from '../../helpers';
// feature load-planner-template
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  itemList: {},
  locations: {},
  loading: false,
};

const setInitialState = () => initialState;

const getItemListSuccess = (state, data) => {
  if (G.isNilOrEmpty(data)) return state;

  const list = R.compose(
    G.indexByGuid,
    G.mapIndexed((item, index) => R.mergeRight(
      item,
      {
        index,
        expanded: false,
        disabled: G.isFalse(G.getPropFromObject('editable', item)),
      },
    )),
  )(data);

  return P.$set('itemList', list, state);
};

const removeLoadPlannerTemplateSuccess = (state, guid) => (
  P.$drop(`itemList.${guid}`, state)
);

const setListLoading = (state, data) => (
  P.$set('loading', data, state)
);

const toggleLoadPlannerTemplateDetails = (state, { guid }) => (
  P.$toggle(`itemList.${guid}.expanded`, state)
);

const getCrossDockLocationsSuccess = (state, data) => {
  if (G.isNilOrEmpty(data)) return state;

  const locations = G.indexByGuid(data);

  return P.$set('locations', locations, state);
};

export default createReducer({
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.getCrossDockLocationsSuccess]: getCrossDockLocationsSuccess,
  [A.toggleLoadPlannerTemplateDetails]: toggleLoadPlannerTemplateDetails,
  [A.removeLoadPlannerTemplateSuccess]: removeLoadPlannerTemplateSuccess,
}, initialState);
